import { Images } from "../../Assets/Index";
import { useDispatch, useSelector } from "react-redux";
import { dispatchtoast, getLocalStorageItem } from "../../Utils";

import { Avatar, Button, DatePicker, Select } from "antd";
import { LiaCitySolid } from "react-icons/lia";
import { PiCity } from "react-icons/pi";
import { IoCaretBack } from "react-icons/io5";
import { BiDownArrow } from "react-icons/bi";
import { FaAngleDown, FaCalendar } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { useCommmonStore } from "../../Store/CommonReducer";
import MyGameList from "./MyGameList";
import { useState } from "react";
import dayjs from "dayjs";
const Match = () => {
  const walletBalance = useSelector((state) => state.colorGame.walletBal);
  const withdrawAmount = useSelector((state) => state.colorGame.withdrawAmt);
  const navigate = useNavigate();
  const [openGameList, setOpenGameList] = useState(false);
  const [game, setGame] = useState("");
  const [gameType, setGameType] = useState("");
  const [startDate, setStartDate] = useState(false);
  const [endDate, setEndDate] = useState(false);

  const [date, setDate] = useState(false);
  const { profileDetail } = useCommmonStore();
  return (
    <>
      <div className="flex justify-center  items-center bg-black rounded-lg">
        <div className="w-full ">
          <div className="flex justify-between bg-gradient-to-r from-[#734e0c] via-[#ba7d13] to-[#e9a52f] px-8  py-2 gap-x-3 items-center ">
            <div className="text-white font-semibold flex  items-center gap-4 ">
              <IoCaretBack
                className="bg-[#ba7d13] h-7 w-7 rounded-lg cursor-pointer text-white"
                onClick={() => navigate("/home")}
              />
              <p className="text-xl font-normal custome">
                {/* {getLocalStorageItem("userDetails")?.name}My Match */}
                My Match
              </p>
            </div>
            <div className="flex justify-between items-center">
              <img src={Images.Money} className="w-8 m-auto my-2" alt="money" />
              <p className="text-white text-sm  custome">
                ₹ {profileDetail?.user?.wallet_balance ?? 0}
              </p>
            </div>
          </div>
          <div className="h-[100vh] bg-black overflow-scroll">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 items-center rounded-lg mt-6">
              <div className="ml-4">
                <p className="text-white custome text-sm">Select Game</p>
                <Select
                  defaultValue={game}
                  style={{ width: 200 }}
                  placeholder="Select Game"
                  suffixIcon={<FaAngleDown className="text-gray-400" />}
                  className="custom-select text-white font-[cursive]"
                  options={[
                    { value: "aviator", label: "Aviator" },
                    { value: "number", label: "Number" },
                    { value: "plinko", label: "Plinko" },
                    { value: "mines", label: "Mines" },
                  ]}
                  onChange={(val) => {
                    setGame(val);
                    setOpenGameList(false);
                    setGameType("");
                  }}
                />
              </div>
              <div className="ml-4">
                <p className="text-white custome text-sm">Game Type</p>
                <Select
                  disabled={game === "number" ? false : true}
                  className="custom-select text-white font-[cursive]"
                  defaultValue={gameType}
                  style={{
                    width: 200,
                  }}
                  placeholder="Game Type"
                  suffixIcon={<FaAngleDown className="text-gray-400" />}
                  options={[
                    { value: "desawar", label: "Desawar" },
                    { value: "dubai", label: "Dubai Market" },
                    { value: "faridabad", label: "Faridabad" },
                    { value: "ghaziabad", label: "Ghaziabad" },
                    { value: "gali_number", label: "Gali" },
                    { value: "delhi", label: "Delhi City" },
                  ]}
                  onChange={(val) => setGameType(val)}
                />
              </div>
              <div className="ml-4">
                <p className="text-white custome text-sm">Select Start Date</p>
                <DatePicker
                  onChange={(val) => {
                    const formatted = val
                      ? dayjs(val).format("YYYY-MM-DD")
                      : null;
                    setStartDate(formatted);
                  }}
                  suffixIcon={<FaCalendar className="text-gray-400" />}
                  style={{
                    width: 200,
                    background: "#000",
                    border: "1px solid #d9d9d9",
                    fontFamily: "cursive",
                    color: "#fff",
                  }}
                  className="datepicker-placeholder"
                />
              </div>
              <div className="ml-4">
                <p className="text-white custome text-sm">Select End Date</p>
                <DatePicker
                  onChange={(val) => {
                    const formatted = val
                      ? dayjs(val).format("YYYY-MM-DD")
                      : null;
                    setEndDate(formatted);
                  }}
                  suffixIcon={<FaCalendar className="text-gray-400" />}
                  style={{
                    width: 200,
                    background: "#000",
                    border: "1px solid #d9d9d9",
                    fontFamily: "cursive",
                    color: "#fff",
                  }}
                  className="datepicker-placeholder"
                />
              </div>
            </div>
            {game && startDate && endDate ? (
              <Button
                // loading={loading}
                onClick={() => setOpenGameList(true)}
                type="default"
                htmlType="submit"
                className="w-[370px] m-14 custome rounded-3xl h-10 font-medium text-lg border-none
                   text-white bg-gradient-to-r from-[#734e0c] via-[#ba7d13] to-[#e9a52f]
                   hover:bg-gradient-to-r hover:from-[#734e0c] hover:via-[#ba7d13] hover:to-[#e9a52f]"
              >
                Find Match
              </Button>
            ) : (
              ""
            )}
            {openGameList && (
              <MyGameList
                game={game}
                gameType={gameType}
                startDate={startDate}
                endDate={endDate}
              />
            )}
          </div>
          <div className="h-[100vh] bg-black overflow-scroll"></div>
        </div>
      </div>
    </>
  );
};

export default Match;
